var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t("terms"))+"\n  ")]),_vm._v(" "),(_vm.lang_Mobif == 'slovakia')?_c('span',[_c('terms-slovak')],1):_vm._e(),_vm._v(" "),(_vm.lang_Mobif == 'czech')?_c('span',[_c('terms-czech')],1):_c('span',[_c('terms-english')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46b14e4d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobiflix/Terms.vue
// module id = 1680
// module chunks = 0